import React from 'react';
import classNames from 'classnames';

import { TRate } from '@sv-support-sdk/shared-types/src/common/chats';

// @ts-ignore
import smile1 from '../../../assets/images/smile-1.png';
// @ts-ignore
import smile2 from '../../../assets/images/smile-2.png';
// @ts-ignore
import smile3 from '../../../assets/images/smile-3.png';
// @ts-ignore
import smile4 from '../../../assets/images/smile-4.png';
// @ts-ignore
import smile5 from '../../../assets/images/smile-5.png';
import { $l } from '../../../locales';

import css from './style.module.scss';

interface Props {
  score: TRate;
  size?: 'normal';
}

const rateOptions = {
  1: { src: smile1, alt: 'Rating 1', text: $l('CHAT.RATING_1') },
  2: { src: smile2, alt: 'Rating 2', text: $l('CHAT.RATING_2') },
  3: { src: smile3, alt: 'Rating 3', text: $l('CHAT.RATING_3') },
  4: { src: smile4, alt: 'Rating 4', text: $l('CHAT.RATING_4') },
  5: { src: smile5, alt: 'Rating 5', text: $l('CHAT.RATING_5') },
};

const Smile = ({ score, size = 'normal' }: Props) => {
  if (!score) return null;

  return (
    <img
      className={classNames(css.smile, {
        [css[`smile_size_${size}`]]: size,
      })}
      src={rateOptions[score].src}
      alt={rateOptions[score].alt}
    />
  );
};

export default Smile;
